// extracted by mini-css-extract-plugin
export default {"footer":"styles-module--footer--_H73m","footerText":"styles-module--footerText--Vmy7H"};